export interface ITipoPregunta {
  idTipoPregunta: string;
  nombre: string;
  descripcion: string;
}

export class TipoPregunta {
  idTipoPregunta: string;
  nombre: string;
  descripcion: string;

  constructor(data: ITipoPregunta) {
    this.idTipoPregunta = data.idTipoPregunta;
    this.nombre = data.nombre;
    this.descripcion = data.descripcion;
  }
}
